module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "headLine"
  }, [_vm._v("用户审核")]), _vm._v(" "), _c('div', {
    staticClass: "subpage ent_edit"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "show-message": false
    }
  }, [_c('div', {
    staticClass: "selects"
  }, [_c('div', {
    staticClass: "select-line"
  }, [_c('div', {
    staticClass: "selectGp"
  }, [_c('span', {
    staticClass: "cName"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "disabled": true,
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "selectGp"
  }, [_c('span', {
    staticClass: "cName"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "disabled": true,
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.params.phone),
      callback: function($$v) {
        _vm.$set(_vm.params, "phone", $$v)
      },
      expression: "params.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "selectGp"
  }, [_c('span', {
    staticClass: "cName"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "disabled": true,
      "placeholder": ""
    },
    model: {
      value: (_vm.params.email),
      callback: function($$v) {
        _vm.$set(_vm.params, "email", $$v)
      },
      expression: "params.email"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "select-line"
  }, [_c('div', {
    staticClass: "selectGp"
  }, [_c('span', {
    staticClass: "cName"
  }, [_vm._v("所在街乡")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "jiexiang"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "disabled": true,
      "placeholder": ""
    },
    model: {
      value: (_vm.params.jiexiang),
      callback: function($$v) {
        _vm.$set(_vm.params, "jiexiang", $$v)
      },
      expression: "params.jiexiang"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "selectGp"
  }, [_c('span', {
    staticClass: "cName"
  }, [_vm._v("所在单位")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "danwei"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "disabled": true,
      "placeholder": ""
    },
    model: {
      value: (_vm.params.danwei),
      callback: function($$v) {
        _vm.$set(_vm.params, "danwei", $$v)
      },
      expression: "params.danwei"
    }
  })], 1)], 1), _vm._v(" "), (_vm.params.type != 2) ? _c('div', {
    staticClass: "selectGp"
  }, [_c('span', {
    staticClass: "cName"
  }, [_vm._v("所属功能区")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "ownePark"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "disabled": true,
      "placeholder": ""
    },
    model: {
      value: (_vm.params.ownePark),
      callback: function($$v) {
        _vm.$set(_vm.params, "ownePark", $$v)
      },
      expression: "params.ownePark"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "select-line"
  }, [_c('div', {
    staticClass: "selectGp"
  }, [_c('span', {
    staticClass: "cName"
  }, [_vm._v("机构")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "organizationId"
    }
  }, [_c('el-cascader', {
    staticClass: "inpText",
    attrs: {
      "collapse-tags": "",
      "clearable": "",
      "size": "medium",
      "placeholder": _vm.plaText,
      "options": _vm.orgArr,
      "show-all-levels": false,
      "props": {
        value: 'id',
        label: 'name',
        children: 'getCompanyPostModules',
        multiple: false,
        emitPath: false
      }
    },
    on: {
      "change": _vm.selectTreeChange
    },
    model: {
      value: (_vm.params.organizationId),
      callback: function($$v) {
        _vm.$set(_vm.params, "organizationId", $$v)
      },
      expression: "params.organizationId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "selectGp"
  }, [_c('span', {
    staticClass: "cName"
  }, [_vm._v("权限")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "rulePostId"
    }
  }, [_c('el-select', {
    staticClass: "inpText",
    attrs: {
      "clearable": "clearable",
      "size": "medium"
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.params.rulePostId),
      callback: function($$v) {
        _vm.$set(_vm.params, "rulePostId", $$v)
      },
      expression: "params.rulePostId"
    }
  }, _vm._l((_vm.selectArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "select-line"
  }, [_c('div', {
    staticClass: "selectGp"
  }, [_c('span', {
    staticClass: "cName"
  }, [_vm._v("审核")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "status"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("不通过")])], 1)], 1)], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "btnLine"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.review()
      }
    }
  }, [_vm._v("审核")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.pageBack
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-bfd0e4f8"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/pgment/register/userReview.vue
// module id = 1555
// module chunks = 1